import '../../styles/components/cart.scss';
import '../../styles/components/checkbox.scss';
import {themeI18n} from '../utils/i18n_helper'

import {
  changeCart,
  updateAttributes,
  updateNote
} from '../utils/cart';

class DynamicCart extends HTMLElement {
  constructor() {
    super();

    this.noteTimeout;

    this.loadingFunction = this.loading.bind(this);
    this.openCartFunction = this.openCart.bind(this);
    this.updateCartFunction = this.updateCart.bind(this);
    this.quantityChangeFunction = this.quantityChange.bind(this);
    this.removeItemFunction = this.removeItem.bind(this);
    this.attributesChangeFunction = this.attributesChange.bind(this);
    this.updateNoteFunction = this.updateNote.bind(this);

    this.connect();
  }

  connect() {
    this.form = this.querySelector('form');
    this.quantityInputs = Array.from(this.querySelectorAll('[data-input-item-key]'));
    this.removeButtons = Array.from(this.querySelectorAll('[data-remove-item]'));
    this.attributesInputs = Array.from(this.querySelectorAll('[data-cart-attributes]'));
    this.noteInput = this.querySelector('[data-cart-note]');

    window.addEventListener('dynamic-cart-loading', this.loadingFunction);
    window.addEventListener('dynamic-cart-open', this.openCartFunction);
    window.addEventListener('ajax-cart', this.updateCartFunction);

    this.quantityInputs.forEach(input => {
      input.addEventListener('change', this.quantityChangeFunction);
    });

    this.removeButtons.forEach(button => {
      button.addEventListener('click', this.removeItemFunction);
    });

    this.attributesInputs.forEach(input => {
      input.addEventListener('change', this.attributesChangeFunction);
    });

    if (this.noteInput) {
      this.noteInput.addEventListener('input', this.updateNoteFunction);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('dynamic-cart-loading', this.loadingFunction);
    window.removeEventListener('dynamic-cart-open', this.openCartFunction);
    window.removeEventListener('ajax-cart', this.updateCartFunction);

    this.quantityInputs.forEach(input => {
      input.removeEventListener('change', this.quantityChangeFunction);
    });

    this.removeButtons.forEach(button => {
      button.removeEventListener('click', this.removeItemFunction);
    });

    this.attributesInputs.forEach(input => {
      input.removeEventListener('change', this.attributesChangeFunction);
    });

    if (this.noteInput) {
      this.noteInput.removeEventListener('input', this.updateNoteFunction);
    }
  }

  openCart() {
    const closestDetails = this.closest('details-disclosure');
    closestDetails.open('no-scroll--cart');
  }

  loading() {
    this.form.classList.add('loading', "loading");
  }

  stopLoading() {
    this.form.classList.remove('loading', "loading");
  }

  quantityChange(event) {
    const currentQuantityInput = event.currentTarget;
    const value = parseInt(currentQuantityInput.value);
    const max = currentQuantityInput.max ? parseInt(currentQuantityInput.max) : null;
    const min = currentQuantityInput.min ?  parseInt(currentQuantityInput.min) : null;
    const step = currentQuantityInput.step ?  parseInt(currentQuantityInput.step) : null;

    let error = null;

    if (max && value > max) {
      error = themeI18n('cart.error.max_error', {max: max});
    } else if (min != 0 && value < min) {
      error = themeI18n('cart.error.min_error', {min: min});
    } else if (step && value % step != 0) {
      error = themeI18n('cart.error.step_error', {step: step});
    }

    if (error != null) {
      window.toast.error({
        message: error,
        icon: false
      })

      // Reset input to previous value due to error
      const previousQuantity = parseInt(currentQuantityInput.dataset.cartQuantity);
      currentQuantityInput.value = previousQuantity;
      return;
    }

    changeCart(currentQuantityInput.dataset.inputItemKey, currentQuantityInput.value);
  }

  removeItem(event) {
    event.preventDefault();

    const currentQuantityInput = event.currentTarget;

    changeCart(currentQuantityInput.dataset.removeItem, 0);
  }

  updateCart(event) {
    if (!event.detail.cartSections) {
      // If there are no cart sections, there likely was an error, a toast notification will be shown by the utils/cart.js file, so we can just stop the loading state here.
      this.stopLoading();
      return;
    }

    const isCartPage = window.location.pathname.includes('/cart');
    const sectionHTML = isCartPage ? event.detail.cartSections['cart-main'] : event.detail.cartSections['header'];

    const parsedHtmlSections = Array.from(new DOMParser()
        .parseFromString(sectionHTML, 'text/html')
        .querySelectorAll('[data-cart-content]'));

    parsedHtmlSections.forEach(section => {
      const sectionName = section.dataset.cartContent;
      const sectionHtml = section.innerHTML;

      document.querySelector(`[data-cart-content="${sectionName}"]`).innerHTML = sectionHtml;
    });

    this.stopLoading();
    this.disconnectedCallback();
    this.connect();
  }

  attributesChange(event) {
    const currentAttributesInput = event.currentTarget;

    const attributes = {};

    if (currentAttributesInput.type === 'checkbox') {
      if (currentAttributesInput.checked) {
        attributes[currentAttributesInput.dataset.attribute] = currentAttributesInput.value;
      }
      else {
        attributes[currentAttributesInput.dataset.attribute] = null;
      }
    }
    else {
      attributes[currentAttributesInput.dataset.attribute] = currentAttributesInput.value;
    }

    updateAttributes(attributes);
  }

  updateNote() {
    clearTimeout(this.noteTimeout);

    this.noteTimeout = setTimeout(() => {
      updateNote(this.noteInput.value);
    }, 1000);
  }
}

try {
  customElements.define('dynamic-cart', DynamicCart)
}
catch(e) {}
